import React, { useEffect, useState } from 'react';
import { 
  Carousel,
  Image,
  Row,
  Col,
  Container,
  Button
} from 'react-bootstrap';
import VisaLogo from '../../../../img/Visa.png';
import MasterLogo from '../../../../img/Mastercard.png';
import Translate from '../../../../../../translate';
import Puntitos from '../../../../img/graficos/PuntitosCuadro – 1.png';
import CirculoPuntitosAzul from '../../../../img/graficos/CirculoPuntitosAzul.svg';
import BitCoinLogo from '../../../../img/iconos/bitcoinmorado.svg';
import CardPayment from '../../../../img/iconos/card-payment.svg';
import '../index.css';

const CarouselComisiones = ({lan, id}) => {
  const [tabState, setTabState] = useState('fisica' | 'moral');

  useEffect(() => {
    setTabState('fisica')
  }, [])

  return(
    <div className="comisiones-background section-container" id={id}>
      <Carousel
        indicators={false}
        interval={null}
      >
        <Carousel.Item>
          <div className='comisiones-outter'>
            <Container>
              <Row>
                <Col xl={5} lg={6} className="align-mobile">
                  <div className='comisiones-container'>
                    <p className='comisiones-title'>
                      {Translate[lan].landing3.seccion5.titulo}
                      <br/>
                      <span className='comisiones-subtitle'>{Translate[lan].landing3.seccion5.subtitulo}</span>
                      <br/>
                      <span className='comisiones-subtitle'>{Translate[lan].landing3.seccion5.subtitulo2}</span>
                    </p>
                    <Button className='main-button' onClick={()=>window.open(window.location.origin + '/register','_blank')} >{Translate[lan].landing3.boton}</Button>
                    {/* <div style={{marginTop:15, marginLeft:0}}>
                      <Image src={VisaLogo} className='brandImg2' style={{marginRight:30}}/>
                      <Image src={MasterLogo} className='brandImg2' />
                    </div> */}
                  </div>
                </Col>
                <Col xl={7} lg={6}>
                  <div className='othercommission-container'>
                    <Row>
                      <Col xl={7} lg={6} md={6} sm={6}>
                        <p className='commission-title'>{Translate[lan].landing3.seccion5.bannerTitulo}</p>
                        <p className='commission-subtitle'>{Translate[lan].landing3.seccion5.bannerPorcentaje}</p>
                        {/* <p className='commission-text'>{Translate[lan].landing3.seccion5.bannerComision}</p> */}
                        <div className='commission-separator'/>
                        <p className='commission-subtext'>{Translate[lan].landing3.seccion5.bannerDesc}</p>
                      </Col>
                      <Col xl={5} lg={6} md={6} sm={6} className="align-card">
                        <Image className="card-payment" src={CardPayment}/>
                      </Col>
                    </Row>
                    <Image src={CirculoPuntitosAzul} className='floating-dots'/>
                    <Image src={Puntitos} className='floating-circle-dots'/>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className='comisiones-outter'>
            <Container>
              <Row>
                <Col xl={5} lg={6} className="align-mobile">
                  <div className='comisiones-container'>
                    <p className='comisiones-title'>
                      {Translate[lan].landing3.seccion5.titleCrypto}
                      <br/>
                      <span className='comisiones-subtitle'>{Translate[lan].landing3.seccion5.subtituloCrypto}</span><br/>
                      <span className='comisiones-subtitle'>{Translate[lan].landing3.seccion5.subtituloCrypto2}</span>
                    </p>
                    <Button className='main-button' onClick={()=>window.open(window.location.origin + '/register','_blank')} >{Translate[lan].landing3.boton}</Button>
                  </div>
                </Col>
                <Col xl={7} lg={6}>
                  <div className='othercommission-container-tabs'>
                    <Row>
                      <Col xl={6} lg={6} md={6} sm={6} xs={6} style={{paddingRight: 0}}>
                        <Button
                          style={{borderRadius: '13px 0px 0px 0px'}}
                          className={tabState === 'fisica' ? 'btn-tabs-active' : 'btn-tabs'} 
                          onClick={() => setTabState('fisica')}
                        >
                          {Translate[lan].landing3.seccion5.bannerPersonaFisica}
                        </Button>
                      </Col>
                      <Col xl={6} lg={6} md={6} sm={6} xs={6} style={{paddingLeft: 0}}>
                        <Button
                          style={{borderRadius: '0px 13px 0px 0px'}}
                          className={tabState === 'moral' ? 'btn-tabs-active' : 'btn-tabs'} 
                          onClick={() => setTabState('moral')}
                        >
                          {Translate[lan].landing3.seccion5.bannerPersonaMoral}
                        </Button>
                      </Col>
                    </Row>
                    <Image src={Puntitos} className='dots-comissions'/>
                    <Image src={BitCoinLogo} className='bitcoin-comissions'/>
                    <div style={{padding: '12px 25px', minHeight: '250px', display: 'flex', width: '100%', alignItems: 'center', justifyContent:'center'}}>
                      {
                        tabState === 'fisica' &&
                        <Row style={{width: '100%', flexDirection: 'column'}}>
                          <Col xl={12} sm={12} xs={12} style={{display:'flex'}}>
                            <Col xs={6} className="responsive-text">{Translate[lan].landing3.seccion5.feeVirtual}</Col>
                            <Col xs={2} className="responsive-separator" style={{padding: 0}}><div className='puntitos'/></Col>
                            <Col xs={4} className="align-center responsive-text">{Translate[lan].landing3.seccion5.comision1}</Col>
                          </Col>
                          <Col xl={12} sm={12} xs={12} style={{display:'flex'}}>
                            <Col xs={5} className="responsive-text">{Translate[lan].landing3.seccion5.feeCripto}</Col>
                            <Col xs={3} className="responsive-separator" style={{padding: 0}}><div className='puntitos'/></Col>
                            <Col xs={4} className="align-center responsive-text">{Translate[lan].landing3.seccion5.comision2}</Col>
                          </Col>
                          <Col xl={12} sm={12} xs={12} style={{display:'flex'}}>
                            <Col xs={5} className="responsive-text">{Translate[lan].landing3.seccion5.feeBanco}</Col>
                            <Col xs={3} className="responsive-separator" style={{padding: 0}}><div className='puntitos'/></Col>
                            <Col xs={4} className="align-center responsive-text">{Translate[lan].landing3.seccion5.comision2}</Col>
                          </Col>
                          <Col xl={12} sm={12} xs={12} style={{display:'flex'}}>
                            <Col xs={5} className="responsive-text">{Translate[lan].landing3.seccion5.feeRetiro}</Col>
                            <Col xs={3} className="responsive-separator" style={{padding: 0}}><div className='puntitos'/></Col>
                            <Col xs={4} className="align-center responsive-text">{Translate[lan].landing3.seccion5.comision2}</Col>
                          </Col>
                        </Row>
                      }
                      {
                        tabState === 'moral' &&
                        <Row style={{width: '100%'}}>
                          <Col xl={12} sm={12} xs={12} style={{display:'flex'}}>
                            <Col xs={6} className="responsive-text">{Translate[lan].landing3.seccion5.feeVirtual}</Col>
                            <Col xs={2} className="responsive-separator" style={{padding: 0}}><div className='puntitos'/></Col>
                            <Col xs={4} className="align-center responsive-text">{Translate[lan].landing3.seccion5.comision1}</Col>
                          </Col>
                          <Col xl={12} sm={12} xs={12} style={{display:'flex'}}>
                            <Col xs={5} className="responsive-text">{Translate[lan].landing3.seccion5.feeCripto}</Col>
                            <Col xs={3} className="responsive-separator" style={{padding: 0}}><div className='puntitos'/></Col>
                            <Col xs={4} className="align-center responsive-text">{Translate[lan].landing3.seccion5.comision1}</Col>
                          </Col>
                          <Col xl={12} sm={12} xs={12} style={{display:'flex'}}>
                            <Col xs={5} className="responsive-text">{Translate[lan].landing3.seccion5.feeBanco}</Col>
                            <Col xs={3} className="responsive-separator" style={{padding: 0}}><div className='puntitos'/></Col>
                            <Col xs={4} className="align-center responsive-text">{Translate[lan].landing3.seccion5.comision1}</Col>
                          </Col>
                          <Col xl={12} sm={12} xs={12} style={{display:'flex'}}>
                            <Col xs={5} className="responsive-text">{Translate[lan].landing3.seccion5.feeRetiro}</Col>
                            <Col xs={3} className="responsive-separator" style={{padding: 0}}><div className='puntitos'/></Col>
                            <Col xs={4} className="align-center responsive-text">{Translate[lan].landing3.seccion5.comision1}</Col>
                          </Col>
                        </Row>
                      }
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  )
}

export default CarouselComisiones;